export interface DemandListReturn {
  key: string
  url: string
  scope: string
  scrollY: number
  focusId: string
}

// Positions only, never demand data. Keep separate browser-history entries
// independent, including two differently filtered lists open in one session.
const positions = new Map<string, DemandListReturn>()

export function rememberDemandList(position: DemandListReturn): void {
  positions.delete(position.key)
  positions.set(position.key, position)
  if (positions.size > 20) positions.delete(positions.keys().next().value!)
}

export function recalledDemandList(key: string, scope: string): DemandListReturn | undefined {
  const position = positions.get(key)
  return position?.scope === scope ? position : undefined
}

export function demandListReturnFrom(state: unknown): DemandListReturn | undefined {
  if (!state || typeof state !== 'object' || !('demandListReturn' in state)) return
  const value = state.demandListReturn
  if (!value || typeof value !== 'object') return
  if (
    !('key' in value) || typeof value.key !== 'string' ||
    !('url' in value) || typeof value.url !== 'string' || !/^\/demands(?:\?|$)/.test(value.url) ||
    !('scope' in value) || typeof value.scope !== 'string' ||
    !('scrollY' in value) || typeof value.scrollY !== 'number' ||
    !Number.isFinite(value.scrollY) || value.scrollY < 0 ||
    !('focusId' in value) || typeof value.focusId !== 'string'
  ) return
  return { key: value.key, url: value.url, scope: value.scope, scrollY: value.scrollY, focusId: value.focusId }
}
